/** @format */

import intl from 'react-intl-universal';

export const DASHBOARD_URL = '/dashboard';
export const DOCUMENTS_URL = '/documents';
export const POWERBI_URL = '/powerbi';
export const CONSENT_URL = '/consent';
export const USERS_URL = '/admin/users';
export const ENGAGEMENTS_URL = '/admin/engagements';
export const ENGAGEMENT_GROUP_URL = '/admin/engagement-group';
export const IDVALIDATOR_URL = '/idValidator';
export const MANUALREQUESTQUEUE_URL = '/manualRequestQueue';
export const ENGAGEMENTS_DETAILS = '/admin/engagements/details';
export const ENGAGEMENT_GROUP_DETAILS = '/admin/engagement-group/details';
export const CLIENT_CONF_URL = '/admin/clientConfiguration';
export const HOME_URL = '/home';
export const MESSAGING_URL = '/messages';
export const MESSAGING_COMPOSE_URL = '/messages/compose';
export const LOGIN_URL = '/';
export const AUTH_LOGIN_URL= '/authlogin';
export const LOGOUT_URL = '/?logout';
export const LOGOUT_URL2 = '/logout';
export const CASES_URL = '/cases';
export const TEAM_CASES_URL = '/cases/team';
export const OVERVIEW_CASES_URL = '/cases/overview'
export const CASE_DETAIL_URL = '/cases/detail';
export const CASE_TEAM_DETAIL_URL = '/cases/team/detail';
export const CASE_OVERVIEW_DETAIL_URL = '/cases/overview/detail';
export const QUESTIONNAIRE_URL = '/questionnaire';
export const CHATS_URL = '/chats';
export const SITE_MAINTENANCE_URL = '/site-maintenance';
export const QUESTIONNAIRE_LANDING_URL = `${QUESTIONNAIRE_URL}/:assigneeServicePlanGlobalId/:organizerTypeId/:yearTypeId/:languageId`;
export const QUESTIONNAIRE_SECTION_URL = `${QUESTIONNAIRE_LANDING_URL}/:sectionName`;
export const QUESTIONNAIRE_PAGE_URL = `${QUESTIONNAIRE_SECTION_URL}/:pageId`;
export const QUESTIONNAIRE_COMPLETE_URL = `${QUESTIONNAIRE_PAGE_URL}/complete`;
export const CASE_DETAIL_QUESTIONNAIRE_URL = `${CASE_DETAIL_URL}/:caseManagerId${QUESTIONNAIRE_URL}`;
export const CASE_DETAIL_QUESTIONNAIRE_LANDING_URL = `${CASE_DETAIL_QUESTIONNAIRE_URL}/:assigneeServicePlanGlobalId/:organizerTypeId/:yearTypeId/:languageId`;
export const CASE_DETAIL_QUESTIONNAIRE_SECTION_URL = `${CASE_DETAIL_QUESTIONNAIRE_LANDING_URL}/:sectionName`;
export const DOCUMENTS_DETAIL_URL = '/documents/detail';
export const COUNTRY_CONF_URL = '/admin/country-conf';
export const PRODUCTSERVICES_URL = '/admin/product-services';
export const USERSECURITY_URL = '/admin/users';
export const ADMIN_URL = '/admin';
export const UPLOADS = '/admin/uploads';
export const PREREGISTER_APPLICANTS_URL = '/preregister-applicants';
export const UPLOAD_NEW_URL = '/admin/upload-new';
export const DOC_UPLOAD_NEW_URL = '/documents/upload-new';
export const DOC_REQUEST_NEW_URL = '/documents/request-documents';
export const SERVICEINIT_URL = '/ssi';
export const SERVICEINIT_URL_ADDSI = '/ssi/add';
export const TAXCHAT_SERVICE_INITIATION_URL = '/service-initiation';
export const TAXCHAT_SERVICE_INITIATION_DETAIL_URL = '/service-initiation/detail';
export const HELP_URL = '/help';
export const FORGOT_PASSWORD = '/ForgotPassword';
export const TWO_FACTOR = '/TwoFactor';
export const CASE_UPLOAD_URL = '/case-upload';
export const PROFORMA_UPLOAD = '/proforma-upload';
export const INVALID_TOKEN = 'Invalid Token';
export const APP_UPDATE_URL = '/update-app';
export const TEST_PARSER = '/testparser';
export const LOBBY_MESSAGE_URL = '/admin-lobby-message';
export const PAYWALLREQUESTQUEUE_URL = '/paywallRequest';

export const LANGUAGES = {
  // Values should match with language code
  EN_US: 'en-us',
  FR_CA: 'fr-ca',
  PT_BR: 'pt-br',
  FALLBACK: 'en-us',
};

export const LANGUAGES_DROPDOWN = [
  { value: 'en', code: 'en-us', getLabel: () => intl.get('languages.English') },
  { value: 'fr', code: 'fr-ca', getLabel: () => intl.get('languages.French') },
  { value: 'pt', code: 'pt-br', getLabel: () => intl.get('languages.Brazil') },
];

export const PRIORITY = {
  HIGH: 'High Priority',
  NORMAL: 'Normal Priority',
};

export const FORM_MODE = {
  ADD: 'Add',
  EDIT: 'Edit',
  VIEW: 'View',
  CLOSE: 'Close',
  DELETE: 'Delete',
};

export const BODY_CLASSES = {
  CONSENT: 'consent',
  DASHBOARD: 'dashboard',
  DOCUMENTS: 'documents',
  LOGIN: 'login',
  HOME: 'home',
  MESSAGING: 'messaging',
  CASES: 'cases',
  QUESTIONNAIRE: 'questionnaire',
  ADMIN: 'admin',
  SERVICEINIT: 'serviceinit',
  HELP: 'help',
  ENGAGEMENTS: 'engagements',
  USERS: 'users',
  CHAT: 'chat',
  SITE_MAINTENANCE: 'site-maintenance',
  UPDATE_APP: 'update-app',
  CASE_UPLOAD: 'case-upload',
  PREREGISTER_UPLOAD: 'preregister-applicants',
  PROFORMA_UPLOAD: 'proforma-upload',
  POWERBI: 'powerbi',
  LOBBY_MESSAGE:'lobby-message',
  PAYWALLREQUEST: 'paywall-request',
  TAXCHAT_SERVICE_INITIATION: 'taxchat-service-initiation',
};

/* TIMER TYPES */
export const TIMER_START = '[TIMER][START] Starting interval timer';
export const TIMER_RUNNING = '[TIMER][RUNNING] Running interval timer';
export const TIMER_STOP = '[TIMER][STOP] Stopping interval timer';
export const TIMER_TYPES = {
  MESSAGING: 'messagingMonitor',
  DASHBOARD_COUNTS_MONITOR: 'dashboardCountsMonitor',
  CHAT_COUNTS: 'chatCounts',
  CHAT_MESSAGES: 'chatMessages',
};

export const MAX_ATTEMPTS = 3;

/* MESSAGING CONSTANTS */
export const MESSAGE_PREVIEW_CHARLIMIT = 150;
export const MSG_MONITOR_INTERVAL = 1000 * 60; // 1 minute
export const CHAT_COUNTS_INTERVAL = 900 * 1000; // 15 minute

export const AUTOCOMPLETE_MESSAGING_EMAIL_LIMIT = 5;
export const AUTOCOMPLETE_MESSAGING_CASES_LIMIT = 5;

export const MESSAGEBOX_TYPES = {
  INBOX: 'inbox',
  SENT: 'sent',
  DRAFT: 'draft',
};

export const MESSAGEBOX_VIEWS = {
  NAVIGATION: 'NAVIGATION',
  LIST: 'LIST',
  DETAILS: 'DETAILS',
};

export const MESSAGEDETAIL_TYPES = {
  VIEWMESSAGE: 'VIEWMESSAGE',
  COMPOSE: 'COMPOSE',
  DRAFT: 'DRAFT',
  FORWARD: 'FORWARD',
  REPLY: 'REPLY',
  REPLY_TO_ALL: 'REPLY_TO_ALL',
};

export const MESSAGEORDER_TYPES = {
  ASC: 'asc',
  DESC: 'desc',
};

//fields for filtering
export const CASES_FILTERS = {
  ENGAGEMENTS: 'ENGAGEMENTS',
  ENTITY: 'ENTITY',
  PATHWAY: 'PATHWAY',
  DAYSOLD: 'DAYSOLD',
};

export const TITLES = {
  COMPOSE: 'Compose new message',
  FORWARD: 'Forward message',
  REPLY: 'Reply to message',
  REPLY_TO_ALL: 'Reply to all',
};

export const noData = {
  type: 'nodata',
};

export const MAX_ATTACHMENT_SIZE = 15000000;

export const ATTACHMENT_TYPES = [
  { type: '.ZIP', icon: 'file' },
  { type: '.KEY', icon: 'file' },
  { type: '.CER', icon: 'file' },
  { type: '.XLS', icon: 'excel' },
  { type: '.PDF', icon: 'pdf' },
  { type: '.JPG', icon: 'image' },
  { type: '.BMP', icon: 'image' },
  { type: '.TIF', icon: 'image' },
  { type: '.DOC', icon: 'word' },
  { type: '.TXT', icon: 'document' },
  { type: '.DOCX', icon: 'word' },
  { type: '.DOCM', icon: 'word' },
  { type: '.DOTX', icon: 'word' },
  { type: '.DOTM', icon: 'word' },
  { type: '.XLSX', icon: 'excel' },
  { type: '.XLSM', icon: 'excel' },
  { type: '.XLTX', icon: 'excel' },
  { type: '.XLTM', icon: 'excel' },
  { type: '.XLSB', icon: 'excel' },
  { type: '.XLAM', icon: 'excel' },
  { type: '.DEC', icon: 'file' },
];

export const CMS_ATTACHMENT_TYPES = [
  { type: '.ZIP', icon: 'file' },
  { type: '.XML', icon: 'file' },
  { type: '.XSLT', icon: 'file' },
];

export const TABLE_STATUS = {
  initialize: 'initialize',
  ready: 'ready',
  loading: 'loading',
};

export const IDLE_TIMEOUT = 29 * 60000;
export const INIT_COUNT = 30;
export const DEBOUNCE_SEARCH = 300;

export const SI_ADDINITIATION_VIEWTYPES = {
  SELECT_SERVICETYPE: 'SELECT_SERVICETYPE',
  BATCH_UPLOAD: 'BATCH_UPLOAD',
  ADD_APPLICANT: 'ADD_APPLICANT',
  DYNAMIC_CONTENT: 'DYNAMIC_CONTENT', // Parser/API kicks in here
};

export const SI_INITIATION_TYPES = {
  BATCH_INITIATION: 1783,
  MANUAL_INITIATION: 1782,
};

export const SI_ADD_APPLICANT_VIEWS = {
  SEARCH: 'SEARCH',
  ADDNEW: 'ADDNEW',
};

export const SI_MENU_PAGESTATES = {
  COMPLETE: 'Complete',
  CURRENT_COMPLETE: 'CurrentComplete',
  NOT_VISITED: 'Not_Visited',
  CURRENT_NOT_COMPLETE: 'CurrentNotComplete',
};

export const CREATEORGANIZER_PAGESTATES = {
  COMPLETE: 83, // only 83,84 seem to work?
  INCOMPLETE: 84,
  NOT_VISITED: 85,
  CURRENT_NOT_COMPLETE: 86,
  CURRENT_COMPLETE: 94,
  ENTITY_HEADER: 89,
};

export const USER_ROLES = {
  EY_PROFESSIONAL: 'EY Pro',
  CORPORATE_CLIENT: 'Corporate client',
  APPLICANT: 'TAXCHAT_APPLICANT',
};

export const validRoleCodes = [
  {
    roleKey: 204,
    roleType: 'eyPro',
  },
  {
    roleKey: 202,
    roleType: 'corpClient',
  },
  {
    roleKey: 200,
    roleType: 'applicant',
  },
  {
    roleKey: 203,
    roleType: 'eyAdmin',
  },
  {
    roleKey: 160,
    roleType: 'corporateClientlineManager',
  },
  {
    roleKey: 6702,
    roleType: 'deleteProfile',
  },
  //immichat keys
  {
    roleKey: 107,
    roleType: 'cpsConsentAdmin',
  },
  {
    roleKey: 106,
    roleType: 'cpsSiteAdmin',
  },
  {
    roleKey: 111,
    roleType: 'immiChatApplicant',
  },
  {
    roleKey: 112,
    roleType: 'delegate',
  },
  {
    roleKey: 108,
    roleType: 'deleteProfile',
  },
  {
    roleKey: 109,
    roleType: 'eyAdmin',
  },
  {
    roleKey: 110,
    roleType: 'eyPro',
  },
  {
    roleKey: 10094,
    roleType: 'immiChatSuperAdmin',
  },
  {
    roleKey: 105,
    roleType: 'immiChatUser',
  },
];

export const DASHBOARD_TYPES = {
  NEW_MESSAGES: 'newMessages',
};

// these could be a duplicate of the SSI
// for now we will keep it duplicated until app is complete and we can condense
// unsure if there will be differences between the two (SSI/Applicant)
export const APPLICANT_MENU_PAGESTATES = {
  COMPLETE: 'Complete',
  CURRENT_COMPLETE: 'CurrentComplete',
  NOT_VISITED: 'Not_Visited',
  CURRENT_NOT_COMPLETE: 'CurrentNotComplete',
};

export const FILE_UPLOAD_ERRORS = {
  LIMIT_EXCEEDED: 'limitExceeded',
  DOCUMENT_LIMIT_EXCEEDED: 'documentLimitExceeded',
  UNSUPPORTED: 'unsupported',
  UNSUPPORTED_PREREGISTRATE: 'unsupportedPreregistrate',
  UNSUPPORTED_ZER0_FILE_SIZE: 'unsupportedZeroSizeFile',
};

export const SYSTEM_ROLES = {
  APPLICANT: 'TAXCHAT_APPLICANT',
  CORP_CLIENT: 'Corp Client',
  EY_ADMINISTRATOR: 'EY Administrator',
  EY_PRO: 'EY Pro',
  IML_SUPER_ADMIN: 'TAXCHAT-SUPER-ADMIN',
  IMMIGRATION_APPROVERS: 'Immigration Approvers',
  EXECUTIVE_DELEGATE: 'EXECUTIVE_DELEGATE',
  TAXCHAT_DELEGATE: 'TAXCHAT_DELEGATE',
  DELETE_PROFILE: 'DELETE_PROFILE',
  TAXCHAT_SUPER_ADMIN:'TAXCHAT-SUPER-ADMIN'
};

export const DOCUMENT_SUPPORTED_FILES = [
  '.ZIP',
  '.KEY',
  '.CER',
  '.XLS',
  '.PDF',
  '.JPG',
  '.BMP',
  '.TIF',
  '.DOC',
  '.TXT',
  '.DOCX',
  '.DOCM',
  '.DOTX',
  '.DOTM',
  '.XLSX',
  '.XLSM',
  '.XLTX',
  '.XLTM',
  '.XLSB',
  '.XLAM',
  '.DEC',
  '.JPEG',
  '.PNG',
  '.HEIF',
];

export const CASE_UPLOAD_SUPPORTED_FILES = ['.XLSX', '.XLSM', '.XLTX', '.XLTM', '.XLSB', '.XLAM'];
export const PROFORMA_UPLOAD_SUPPORTED_FILES = ['.ZIP'];
export const IDDOC_VALIDATOR_UPLOAD_SUPPORTED_FILES = ['.PNG', '.JPG', '.GIF', '.JPEG'];
export const DOCUMENT_UPLOAD_TOTAL_MAX_SIZE = 52428800; //50MB
export const DOCUMENT_UPLOAD_INDIVIDUAL_MAX_SIZE = 52428800; //50MB
export const IMG_UPLOAD_INDIVIDUAL_MAX_SIZE = 5242880; //15MB
export const DOCUMENT_ZERO_SIZE = 0; // 0 kb file size

export const DEFAULT_CONTROL_FONT_SIZES = {
  Caption: 14,
  WP: 14,
  CheckBox: 14,
  Radio: 14,
  Header: 32,
  DropDown: 14,
};

export const MIN_DATE = {
  RANGE_SETUP: 1,
};

// any macros (ie: #variable#) need to be provided from the component it's intialized from
// example: this.props.addToHistory(window.location.pathname, { id: this.getCaseManagerId() });
export const HISTORY_URL_MAPPER = {
  '/ssi': 'Service Initiation',
  '/ssi/add': 'Add Initiation',
  '/ssi/add/#id#': 'Service Initiation - ID #id#',
  '/dashboard': 'Dashboard',
  '/documents': 'Documents',
  '/documents/detail/#caseManagerId#/#documentid#': 'Documents Detail - ID: #documentid#',
  '/messages': 'Messages',
  '/messages/compose': 'Compose Message',
  '/documents/upload-new/': 'Upload Documents',
  '/documents/request-documents': 'Request Documents',
  '/help': 'Help',
  '/cases': 'My Cases',
  '/cases/team': 'Team Cases',
  '/cases/detail/#id#': 'Cases Detail - ID #id#',
  '/cases/overview': 'Overview Cases',
  '/cases/overview/detail/#id#': 'Overview Cases Detail - ID #id#',
  '/service-initiation': 'Service Initiation',
  '/service-initiation/detail/#id#': 'Service ID #id#',
};

export const DATE_INPUT_STYLE_TYPES = {
  SERVICE_INITIATION: 'serviceInitation',
};

export const CASES_QUESTIONNAIRE_ACTION_TYPES = {
  DOWNLOAD_PREPROFORMA_XML: 'casesQuestionnaireActionTypes/DOWNLOAD_PREPROFORMA_XML',
  DOWNLOAD_ANSWERKEY_XML: 'casesQuestionnaireActionTypes/DOWNLOAD_ANSWERKEY_XML',
  DOWNLOAD_ORGANIZER_SUMMARY_VIEW: 'casesQuestionnaireActionTypes/DOWNLOAD_ORGANIZER_SUMMARY_VIEW',
  DOWNLOAD_ORGANIZER_SUMMARY_ASSIGNEE: 'casesQuestionnaireActionTypes/DOWNLOAD_ORGANIZER_SUMMARY_ASSIGNEE',
  OPEN_WORKPAPER: 'casesQuestionnaireActionTypes/OPEN_WORKPAPER',
  OPEN_APPLICANT_QUESTIONNAIRE: 'casesQuestionnaireActionTypes/OPEN_APPLICANT_QUESTIONNAIRE',
};

export const WORK_PAPER = {
  PRODUCT_TYPE_AB: 'IMM',
  COUNTRY_AB: 'AB',
};

export const INSTRUMENTATION_KEYS = {
  STG: 'c1181b90-8e22-4a29-938b-c67e979f5fe3',
  PROD: '96190a66-8381-4172-8b71-7f0026ba057e',
  azureDEV: '72e9a756-af37-4c9d-9fc7-6b83ef3f63b1',
  azureDEV2: '72e9a756-af37-4c9d-9fc7-6b83ef3f63b1',
  azureQA: '15c3a653-3b48-461a-94d2-e28ac5551157',
  azureQA2: '15c3a653-3b48-461a-94d2-e28ac5551157',
  azureUAT: 'b65855b2-17e2-412e-8bd3-56e28830f853',
  azureUAT2: 'b65855b2-17e2-412e-8bd3-56e28830f85',
};

export const PACKAGE_TYPE_CONDITIONS_ARRAY = ['SERVICESLIST', 'TAXCHATCONFIG', 'IDParameters'];
export const POLLING_QUEUE_COLUMNS = [
  'clientRefernceID',
  'createdDate',
  'disableRetrieveButton',
  'documentType',
  'experianManualRequestQueueId',
  'requestType',
  'retrievalID',
  'status',
  'statusId',
];
export const SWITCH_TO_VIEW = {
  dashboard: 'IDVALIDATOR_DASHBOARD',
  previewSummary: 'IDVALIDATOR_PREVIEW_SUMMARY',
  pollingQueue: 'IDVALIDATOR_POLLING_QUEUE',
  confirmDialog: 'CONFIRMDIALOG',
  alertDialog: 'ALERTDIALOG',
};

//ImmiChat Key Integration
export const IS_APP_IMMICHAT = window.location.href.indexOf('immichat') > -1;
